<template>
  <div>
    <add-company-component
      :company-data-prop="companyDataComputed"
      :is-edit="isEdit" 
      v-if="companyDataComputed"/> 

  </div>
    
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import AddCompanyComponent from "../../components/AddCompanyComponent";

  export default {
    name: "Edit",
    components: {AddCompanyComponent},
    data() {
      return {
        isEdit: true,
      }
    },
    async created() {
      this.$vs.loading({ text: 'Loading Company Details' })
      if (this.companies.length === 0) {
        await this.loadAllCompanies({
          storeName: 'companies',
          url: `admin/companies`,
          commitUrl: 'companies/SET_COMPANIES',
        })
      }
      await this.loadCompanyItemFun()
      this.$vs.loading.close()
    },
    computed: {
      ...mapGetters({
        companies: 'companies/companiesList',
        companyData: 'companies/editItem',
        isLoading: 'companies/isLoading',
        error: 'companies/error',
      }),
      listingDataComputed() {
        return this.listingData
      },
      companyDataComputed() {
        return this.companyData
      },
    },
    methods: {
      ...mapActions({
        loadAllCompanies: 'get',
        loadItem: 'getLocalItem',
      }),
      loadCompanyItemFun() {
        this.loadItem({
          commitUrl: 'companies/GET_COMPANY',
          id: this.$route.params.companyID
        })
      }
    }
  }
</script>
